import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 数値表示フィールド
 *【ラベル内容:label:string】
 *【内容:content:number】
 *【表示条件:visible:boolean】
 *【パーセント表示:percent:boolean】
 *【小数表示:decimalDisplay:boolean】
 *【小数桁数:decimalDigit:number】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-number-display-field',
  templateUrl: './number-display-field.html',
  styles: [`
    label.label {
      font-size: 10px;
      display: inline-block;
      width: 110px;
      color: rgba(0, 0, 0, .54);
     }
        
    .value {
      font-size: 12px;
      margin-right: 10px;
    }
  `]
})
export class NumberDisplayField extends BaseWidget {
  /**
   * ラベル内容
   */
  @Input() label:string

  /**
   * 内容
   */
  @Input() content:number

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * パーセント表示
   */
  @Input() percent:boolean

  /**
   * 小数表示
   */
  @Input() decimalDisplay:boolean

  /**
   * 小数桁数
   */
  @Input() decimalDigit:number

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  ngOnInit() {
    if (!this.content) {
      this.content = 0;
    }
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/number-display-field/number-display-field.component.ts